<script setup lang="ts">
import AdminOrdersTab from '@/components/AdminOrdersTab.vue';
import AdminUsersTab from '@/components/AdminUsersTab.vue';
import { ref } from 'vue';

const tab = ref(null);
</script>

<template>
  <v-card>
    <v-tabs v-model="tab" align-tabs="center" bg-color="teal-accent-4" stacked>
      <v-tab value="tab-1">
        <v-icon icon="mdi-account"></v-icon>

        Utilisateurs
      </v-tab>

      <v-tab value="tab-2">
        <v-icon icon="mdi-cart"></v-icon>

        Commandes
      </v-tab>
    </v-tabs>

    <v-tabs-window v-model="tab">
      <!-- Users -->
      <v-tabs-window-item :key="1" :value="'tab-1'">
        <AdminUsersTab />
      </v-tabs-window-item>

      <!-- Orders -->
      <v-tabs-window-item :key="2" :value="'tab-2'">
        <AdminOrdersTab />
      </v-tabs-window-item>
    </v-tabs-window>
  </v-card>
</template>

<style scoped></style>
